<script>
import { mapGetters } from 'vuex';
import SLSMarcaService from '@/services/SistemaDKP/sls-marca.service';
import { BOverlay } from 'bootstrap-vue';
import ProductionItem from '@/views/app/CartECommerce/catalogo-produtos/ProductionItem.vue';
import _ from 'lodash';
import SLSEsPrioriService from '@/services/SistemaDKP/SLSEsPriori.service';

const slsEsPrioriService = new SLSEsPrioriService();

export default {
  name: 'ProdutosPorMarca',
  components: {
    ProductionItem: () => import('@/views/app/CartECommerce/catalogo-produtos/ProductionItem.vue'),
    BOverlay,
  },
  data() {
    return {
      showLoading: false,
      codMarca: null,
      currentCategoria: null,
      currentReferencia: '',
      slsMarcaService: new SLSMarcaService(),
      currentPage: 1,
      pageSize: 8,
      lastFetchCount: 0,
      totalProducts: 0,
    };
  },
  computed: {
    ...mapGetters('slsMarca', {
      getCatalogMarca: 'getCurrentCatalogoMarca',
    }),
    brandName() {
      return this.getCatalogMarca?.des_marca || 'Catálogo';
    },
    hasCatalogPDF() {
      return this.getCatalogMarca?.caminho_catalogo;
    },
    productsCount() {
      return this.totalProducts || this.$store.getters['slsMarca/getImagensPorMarca']?.length || 0;
    },
    hasActiveFilters() {
      return this.currentCategoria || this.currentReferencia.trim();
    },
    hasNextPage() {
      if (this.totalProducts) {
        return this.currentPage < Math.ceil(this.totalProducts / this.pageSize);
      }
      return this.lastFetchCount === this.pageSize;
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    totalPages() {
      return this.totalProducts ? Math.ceil(this.totalProducts / this.pageSize) : 1;
    },
  },
  methods: {
    async fetchPage(page) {
      this.showLoading = true;
      this.currentPage = page;

      try {
        const imageParams = {
          limit: this.pageSize,
          offset: (this.currentPage - 1) * this.pageSize,
          images_limit: 5,
        };

        if (this.currentCategoria) {
          imageParams.cod_categ = this.currentCategoria.cod_categ;
        }

        if (this.currentReferencia.trim()) {
          imageParams.familia_comercial_id = this.currentReferencia.trim();
        }

        if (this.currentCategoria) {
          await this.slsMarcaService.listarReferenciasPorCategoriaCodMarca(
            this.currentCategoria.cod_marca,
            this.currentCategoria.cod_categ,
          );
        }

        const result = await this.slsMarcaService.listarImagensPorMarca(this.codMarca, imageParams);
        const items = Array.isArray(result) ? result : result?.data || [];
        this.lastFetchCount = items.length;
        this.totalProducts = Array.isArray(result) ? items.length : result?.total || items.length;
      } catch (error) {
        console.error('Erro ao carregar página:', error);
        this.$bvToast.toast('Erro ao carregar produtos', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.showLoading = false;
      }
    },
    async onPesquisar() {
      await this.fetchPage(1);
    },
    async onLimparFiltros() {
      this.currentCategoria = null;
      this.currentReferencia = '';
      this.currentPage = 1;

      this.$store.commit('slsMarca/clearImagensPorMarca');
      this.$store.commit('slsMarca/clearReferencias');

      await this.fetchPage(1);
    },
    async onLoadingReferenciasAndCategoria(dataReferencia) {
      this.currentReferencia = dataReferencia?.CodReferencia || '';
      await this.fetchPage(1);
    },
    verificarMarca() {
      if (this.codMarca === null) {
        this.$router.push({ name: 'home' });
      }
    },
    downloadCatalogoPDF() {
      this.verificarMarca();
      const link = document.createElement('a');
      link.href = this.getCatalogMarca.caminho_catalogo;
      link.download = 'catalogo.pdf';
      link.click();
    },
    clearData() {
      this.currentCategoria = null;
      this.currentReferencia = '';
      this.currentPage = 1;
      this.lastFetchCount = 0;
      this.totalProducts = 0;
      this.$store.commit('slsMarca/setCurrentCatalogoMarca', {
        log_img_id: '',
        cod_marca: '',
        caminho: '',
        des_marca: '',
        usuario_id: '',
        usuario_nome: '',
        updated_at: '',
        caminho_catalogo: '',
        caminho_img_footer_principal: '',
        caminho_img_footer_secundaria: '',
        cor_cabecalho_marca: '',
        caminho_img_cabec_marcas: '',
        ordem_visualizacao: '',
      });
    },
    onGoToPreviousPage() {
      if (!this.hasPreviousPage) return;
      this.fetchPage(this.currentPage - 1);
    },
    onGoToNextPage() {
      if (!this.hasNextPage) return;
      this.fetchPage(this.currentPage + 1);
    },
  },
  async mounted() {
    this.showLoading = true;

    try {
      if (typeof this.$route.params.codMarca === 'undefined') {
        this.$router.push({ name: 'home' });
        return;
      }

      this.codMarca = this.$route.params.codMarca;

      await Promise.all([
        slsEsPrioriService.selectPrioridadePedido(),
        this.slsMarcaService.obterMarcarPorCodMarca(this.codMarca),
        this.slsMarcaService.listarCategoriasPorMarca(this.codMarca),
      ]);

      await this.fetchPage(1);
    } catch (error) {
      this.$router.push({ name: 'home' });
    } finally {
      this.showLoading = false;
      this.$nextTick(() => {});
    }
  },
  destroyed() {
    this.clearData();
  },
};
</script>

<template>
  <div class="catalog-page">
    <b-overlay variant="light" :show="showLoading" spinner-variant="primary" blur="2px" opacity=".85" rounded="sm">

      <nav class="catalog-breadcrumb">
        <router-link :to="{ name: 'home' }" class="breadcrumb-link">
          <feather-icon icon="HomeIcon" size="14" />
          <span>Home</span>
        </router-link>
        <feather-icon icon="ChevronRightIcon" size="14" class="breadcrumb-separator" />
        <span class="breadcrumb-current">Catálogo</span>
        <template v-if="brandName !== 'Catálogo'">
          <feather-icon icon="ChevronRightIcon" size="14" class="breadcrumb-separator" />
          <span class="breadcrumb-current">{{ brandName }}</span>
        </template>
      </nav>

      <header class="catalog-header">
        <div class="header-left">
          <div class="brand-chip" v-if="getCatalogMarca.caminho_img_cabec_marcas">
            <img
              :src="getCatalogMarca.caminho_img_cabec_marcas"
              :alt="brandName"
              class="brand-chip-logo"
            />
          </div>
          <div class="header-text">
            <h1 class="page-title">Catálogo{{ brandName !== 'Catálogo' ? ` — ${brandName}` : '' }}</h1>
            <p class="page-subtitle">Filtre por categoria ou referência para encontrar os produtos</p>
          </div>
        </div>
      </header>

      <div class="catalog-action-bar">
        <div class="action-bar-filters">
          <div class="filter-field">
            <label class="filter-label">Categoria</label>
            <v-select
              class="filter-select"
              v-model="currentCategoria"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="descricao"
              value="cod_categoria"
              :options="$store.getters['slsMarca/getOptionsCategorias']"
              :disabled="codMarca === null"
              placeholder="Selecione uma categoria"
              :clearable="true"
            />
          </div>

          <div class="filter-field">
            <label class="filter-label">Referência</label>
            <b-form-input
              v-model="currentReferencia"
              class="filter-input"
              placeholder="Digite código ou nome"
              @keyup.enter="onPesquisar"
            />
          </div>

          <div class="filter-buttons">
            <b-button
              class="btn-filter-action btn-primary-action"
              @click="onPesquisar"
              :disabled="!hasActiveFilters"
            >
              <feather-icon icon="SearchIcon" size="16" />
              <span>Buscar</span>
            </b-button>
            <b-button
              class="btn-filter-action btn-secondary-action"
              @click="onLimparFiltros"
              :disabled="!hasActiveFilters"
            >
              <feather-icon icon="XIcon" size="16" />
              <span>Limpar</span>
            </b-button>
          </div>
        </div>

        <div class="action-bar-actions">
          <b-button
            v-if="hasCatalogPDF"
            class="btn-download"
            @click="downloadCatalogoPDF"
          >
            <feather-icon icon="DownloadIcon" size="16" />
            <span>Baixar Catálogo PDF</span>
          </b-button>
        </div>
      </div>

      <div class="catalog-toolbar">
        <div class="toolbar-left">
          <b-button class="btn-back" :to="{ name: 'home' }">
            <feather-icon icon="ArrowLeftIcon" size="16" />
            <span>Voltar</span>
          </b-button>
        </div>
        <div class="toolbar-right">
          <span class="products-count" v-if="productsCount">
            <strong>{{ productsCount }}</strong> produto{{ productsCount !== 1 ? 's' : '' }} encontrado{{ productsCount !== 1 ? 's' : '' }}
          </span>
        </div>
      </div>

      <section class="products-section" v-if="!showLoading">
        <div class="products-grid" v-if="productsCount">
          <div
            v-for="(item, index) in $store.getters['slsMarca/getImagensPorMarca']"
            :key="index"
            class="product-grid-item"
          >
            <production-item :produto="item" />
          </div>
        </div>

        <div class="empty-state" v-else>
          <div class="empty-icon">
            <feather-icon icon="PackageIcon" size="56" />
          </div>
          <h3 class="empty-title">Nenhum produto encontrado</h3>
          <p class="empty-text">Tente ajustar os filtros ou selecionar outra categoria</p>
          <b-button class="btn-reset" @click="onLimparFiltros">
            <feather-icon icon="RefreshCwIcon" size="16" />
            <span>Limpar Filtros</span>
          </b-button>
        </div>
      </section>

      <div class="catalog-pagination" v-if="productsCount && !showLoading">
        <span class="pagination-info">
          Página {{ currentPage }} de {{ totalPages }}
        </span>
        <div class="pagination-actions">
          <b-button class="btn-pagination" :disabled="!hasPreviousPage" @click="onGoToPreviousPage">
            <feather-icon icon="ChevronLeftIcon" size="16" />
            <span>Anterior</span>
          </b-button>
          <b-button class="btn-pagination" :disabled="!hasNextPage" @click="onGoToNextPage">
            <span>Próxima</span>
            <feather-icon icon="ChevronRightIcon" size="16" />
          </b-button>
        </div>
      </div>

    </b-overlay>
  </div>
</template>

<style scoped lang="scss">
.catalog-page {
  background: var(--page-bg, #f8fafc);
  min-height: 100vh;
  padding-bottom: 2rem;
}

.catalog-breadcrumb {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 0.8125rem;
  color: var(--text-muted, #64748b);
}

.breadcrumb-link {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  color: var(--text-muted, #64748b);
  text-decoration: none;
  transition: color 0.15s ease;

  &:hover {
    color: var(--primary, #6366f1);
  }
}

.breadcrumb-separator {
  color: var(--border-color, #e2e8f0);
}

.breadcrumb-current {
  color: var(--text-body, #334155);
  font-weight: 500;
}

.catalog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: var(--card-bg, #ffffff);
  border-bottom: 1px solid var(--border-color, #e2e8f0);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.brand-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  padding: 0.5rem;
  background: var(--surface-bg, #f8fafc);
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: 10px;
  flex-shrink: 0;
}

.brand-chip-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.page-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-heading, #0f172a);
  margin: 0;
  line-height: 1.3;
}

.page-subtitle {
  font-size: 0.8125rem;
  color: var(--text-muted, #64748b);
  margin: 0;
}

.catalog-action-bar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background: var(--card-bg, #ffffff);
  border-bottom: 1px solid var(--border-color, #e2e8f0);
  flex-wrap: wrap;
}

.action-bar-filters {
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
  flex: 1;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  min-width: 180px;
  flex: 1;
  max-width: 240px;
}

.filter-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary, #475569);
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.filter-select {
  ::v-deep .vs__dropdown-toggle {
    background: var(--input-bg, #ffffff);
    border: 1px solid var(--border-color, #e2e8f0);
    border-radius: 6px;
    padding: 0.375rem 0.5rem;
    min-height: 40px;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  ::v-deep .vs__dropdown-toggle:focus-within {
    border-color: var(--primary, #6366f1);
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
  }

  ::v-deep .vs__search {
    color: var(--text-body, #334155);
  }

  ::v-deep .vs__selected {
    color: var(--text-body, #334155);
  }

  ::v-deep .vs__dropdown-menu {
    background: var(--card-bg, #ffffff);
    border: 1px solid var(--border-color, #e2e8f0);
  }

  ::v-deep .vs__dropdown-option--highlight {
    background: var(--primary, #6366f1);
  }
}

.filter-input {
  background: var(--input-bg, #ffffff) !important;
  border: 1px solid var(--border-color, #e2e8f0) !important;
  border-radius: 6px !important;
  padding: 0.5rem 0.75rem !important;
  font-size: 0.875rem;
  height: 40px;
  color: var(--text-body, #334155) !important;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: var(--text-muted, #94a3b8);
  }

  &:focus {
    border-color: var(--primary, #6366f1) !important;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1) !important;
  }
}

.filter-buttons {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.btn-filter-action {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 6px;
  height: 40px;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.btn-primary-action {
  background: var(--primary, #6366f1) !important;
  border: none !important;
  color: #ffffff !important;

  &:hover:not(:disabled) {
    background: var(--primary-dark, #4f46e5) !important;
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.btn-secondary-action {
  background: var(--surface-bg, #f1f5f9) !important;
  border: 1px solid var(--border-color, #e2e8f0) !important;
  color: var(--text-secondary, #475569) !important;

  &:hover:not(:disabled) {
    background: var(--hover-bg, #e2e8f0) !important;
    color: var(--text-body, #334155) !important;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.action-bar-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-download {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 6px;
  height: 40px;
  background: transparent !important;
  border: 1px solid var(--border-color, #e2e8f0) !important;
  color: var(--text-secondary, #475569) !important;
  transition: all 0.15s ease;

  &:hover {
    background: var(--surface-bg, #f1f5f9) !important;
    border-color: var(--primary, #6366f1) !important;
    color: var(--primary, #6366f1) !important;
  }
}

.catalog-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.5rem;
  background: var(--surface-bg, #f8fafc);
  border-bottom: 1px solid var(--border-color, #e2e8f0);
}

.btn-back {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 500;
  border-radius: 6px;
  height: 34px;
  background: var(--card-bg, #ffffff) !important;
  border: 1px solid var(--border-color, #e2e8f0) !important;
  color: var(--text-secondary, #475569) !important;
  transition: all 0.15s ease;

  &:hover {
    background: var(--hover-bg, #f1f5f9) !important;
    color: var(--text-body, #334155) !important;
  }
}

.products-count {
  font-size: 0.8125rem;
  color: var(--text-muted, #64748b);

  strong {
    font-weight: 600;
    color: var(--text-body, #334155);
  }
}

.products-section {
  padding: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1.25rem;
}

.product-grid-item {
  animation: fadeInUp 0.4s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.empty-state {
  text-align: center;
  padding: 3rem 2rem;
  background: var(--card-bg, #ffffff);
  border-radius: 12px;
  border: 1px solid var(--border-color, #e2e8f0);
}

.empty-icon {
  color: var(--text-muted, #cbd5e1);
  margin-bottom: 1rem;
}

.empty-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-heading, #0f172a);
  margin-bottom: 0.375rem;
}

.empty-text {
  font-size: 0.875rem;
  color: var(--text-muted, #64748b);
  margin-bottom: 1.25rem;
}

.btn-reset {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 6px;
  background: var(--primary, #6366f1) !important;
  border: none !important;
  color: #ffffff !important;
}

.catalog-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0 1.5rem 2rem;
  flex-wrap: wrap;
}

.pagination-info {
  font-size: 0.8125rem;
  color: var(--text-muted, #64748b);
}

.pagination-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-pagination {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 6px;
  background: var(--surface-bg, #f1f5f9) !important;
  border: 1px solid var(--border-color, #e2e8f0) !important;
  color: var(--text-secondary, #475569) !important;
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    background: var(--hover-bg, #e2e8f0) !important;
    color: var(--text-body, #334155) !important;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

@media (max-width: 992px) {
  .catalog-action-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .action-bar-filters {
    width: 100%;
  }

  .action-bar-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .filter-field {
    max-width: none;
  }
}

@media (max-width: 768px) {
  .catalog-breadcrumb {
    padding: 0.5rem 1rem;
  }

  .catalog-header {
    padding: 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .header-left {
    width: 100%;
  }

  .brand-chip {
    width: 48px;
    height: 48px;
  }

  .page-title {
    font-size: 1.125rem;
  }

  .catalog-action-bar {
    padding: 1rem;
  }

  .filter-field {
    min-width: 100%;
  }

  .filter-buttons {
    width: 100%;
    justify-content: stretch;
  }

  .btn-filter-action {
    flex: 1;
    justify-content: center;
  }

  .action-bar-actions {
    margin-top: 0.5rem;
  }

  .btn-download {
    width: 100%;
    justify-content: center;
  }

  .catalog-toolbar {
    padding: 0.75rem 1rem;
  }

  .products-section {
    padding: 1rem;
  }
}

body.dark-layout .catalog-page {
  background: var(--dark-page-bg, #161d31);
}

body.dark-layout .catalog-breadcrumb {
  color: var(--dark-text-muted, #9ca3af);
}

body.dark-layout .breadcrumb-link {
  color: var(--dark-text-muted, #9ca3af);

  &:hover {
    color: var(--dark-primary, #a5b4fc);
  }
}

body.dark-layout .breadcrumb-separator {
  color: var(--dark-border, #4b5563);
}

body.dark-layout .breadcrumb-current {
  color: var(--dark-text-body, #d1d5db);
}

body.dark-layout .catalog-header {
  background: var(--dark-card-bg, #283046);
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .brand-chip {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .page-title {
  color: var(--dark-text-heading, #d0d2d6);
}

body.dark-layout .page-subtitle {
  color: var(--dark-text-muted, #9ca3af);
}

body.dark-layout .catalog-action-bar {
  background: var(--dark-card-bg, #283046);
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .filter-label {
  color: var(--dark-text-secondary, #b4b7bd);
}

body.dark-layout .filter-select {
  ::v-deep .vs__dropdown-toggle {
    background: var(--dark-input-bg, #283046);
    border-color: var(--dark-border, #3b4253);
  }

  ::v-deep .vs__search,
  ::v-deep .vs__selected {
    color: var(--dark-text-body, #b4b7bd);
  }

  ::v-deep .vs__dropdown-menu {
    background: var(--dark-card-bg, #283046);
    border-color: var(--dark-border, #3b4253);
  }

  ::v-deep .vs__dropdown-option {
    color: var(--dark-text-body, #b4b7bd);
  }
}

body.dark-layout .filter-input {
  background: var(--dark-input-bg, #283046) !important;
  border-color: var(--dark-border, #3b4253) !important;
  color: var(--dark-text-body, #b4b7bd) !important;

  &::placeholder {
    color: var(--dark-text-muted, #9ca3af);
  }
}

body.dark-layout .btn-secondary-action {
  background: var(--dark-surface-bg, #242b3d) !important;
  border-color: var(--dark-border, #3b4253) !important;
  color: var(--dark-text-secondary, #b4b7bd) !important;

  &:hover:not(:disabled) {
    background: var(--dark-hover-bg, #2d3548) !important;
    color: var(--dark-text-body, #d0d2d6) !important;
  }
}

body.dark-layout .btn-download {
  border-color: var(--dark-border, #3b4253) !important;
  color: var(--dark-text-secondary, #b4b7bd) !important;

  &:hover {
    background: var(--dark-surface-bg, #242b3d) !important;
    border-color: var(--dark-primary, #7367f0) !important;
    color: var(--dark-primary, #7367f0) !important;
  }
}

body.dark-layout .catalog-toolbar {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .btn-back {
  background: var(--dark-card-bg, #283046) !important;
  border-color: var(--dark-border, #3b4253) !important;
  color: var(--dark-text-secondary, #b4b7bd) !important;

  &:hover {
    background: var(--dark-hover-bg, #2d3548) !important;
    color: var(--dark-text-body, #d0d2d6) !important;
  }
}

body.dark-layout .products-count {
  color: var(--dark-text-muted, #9ca3af);

  strong {
    color: var(--dark-text-body, #d1d5db);
  }
}

body.dark-layout .empty-state {
  background: var(--dark-card-bg, #283046);
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .empty-icon {
  color: var(--dark-text-muted, #9ca3af);
}

body.dark-layout .empty-title {
  color: var(--dark-text-heading, #e5e7eb);
}

body.dark-layout .empty-text {
  color: var(--dark-text-muted, #9ca3af);
}

body.dark-layout .pagination-info {
  color: var(--dark-text-muted, #9ca3af);
}

body.dark-layout .btn-pagination {
  background: var(--dark-surface-bg, #242b3d) !important;
  border-color: var(--dark-border, #3b4253) !important;
  color: var(--dark-text-secondary, #b4b7bd) !important;

  &:hover {
    background: var(--dark-hover-bg, #2d3548) !important;
    color: var(--dark-text-body, #d0d2d6) !important;
  }
}
</style>
